import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LicenseDetail from './screens/details';
import { LicensesPage } from './screens/liscensepage';
import Unauthorized from './screens/unautherized';
import GEGDashboard from './screens/admindashboard';

function App() {
  return (
      <Routes>

        <Route path="/licenses" element={<LicensesPage />} />
        <Route path="/" element={<GEGDashboard />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/details/:type/:pan" element={<LicenseDetail />} />
        <Route path="*" element={<div style={{padding: '20px'}}>Page Not Found</div>} />
      </Routes>
   
  );
}

export default App;